module.exports = __webpack_public_path__ + "img/Framework.9daf8f1a.png";